import { useMemo } from 'react';
import { Dimensions, Platform } from 'react-native';

import { SizeBreakpoint } from '../../../../enums/size-breakpoint';

export interface CarouselDimensions {
  containerWidth: number;
  cardGap: number;
  cardWidth: number;
  cardHeight: number;
}

const useTabActivityCarouselDimensions = (
  minCardWidth: number
): CarouselDimensions => {
  const containerWidth = Math.trunc(Dimensions.get('window').width);

  const cardDimensions = useMemo(() => {
    const cardWidth =
      containerWidth < SizeBreakpoint.MD ? containerWidth - 48 : minCardWidth;

    const cardHeight =
      Platform.OS === 'web' ? cardWidth * 1.3 : cardWidth * 1.25;

    const cardGap =
      containerWidth < SizeBreakpoint.MD
        ? 0
        : containerWidth < cardWidth * 5
        ? cardWidth / 5
        : cardWidth / 2;

    return {
      cardWidth,
      cardHeight,
      cardGap,
    };
  }, [containerWidth, minCardWidth]);

  return {
    containerWidth,
    ...cardDimensions,
  };
};

export default useTabActivityCarouselDimensions;
